import {
  AfterContentInit,
  Component,
  ContentChild,
  Input,
  OnInit,
} from '@angular/core';
import { FormControlName } from '@angular/forms';
import { AutoUnsubscribeComponent } from '@wz-utilities/auto-unsubscribe.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'wz-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  standalone: false,
})
export class FormFieldComponent
  extends AutoUnsubscribeComponent
  implements OnInit, AfterContentInit
{
  @ContentChild(FormControlName, { static: true }) formControl!:
    | FormControlName
    | any;
  @Input() label!: string;
  public hasError = false;
  ngOnInit(): void {}

  constructor() {
    super();
  }

  ngAfterContentInit() {
    if (this.formControl) {
      this.formControl.statusChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe((_: any) => {
          this.hasError = this.formControl.dirty && !!this.formControl.errors;
        });
    }
  }
}
